import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinchZoomIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.55 22C14.2667 22 14 21.9457 13.75 21.837C13.5 21.729 13.2833 21.5833 13.1 21.4L7.95 16.25L9.35 14.8C9.58333 14.5667 9.846 14.3873 10.138 14.262C10.4293 14.1373 10.7333 14.1167 11.05 14.2L13 14.65V6.5C13 5.8 13.2417 5.20833 13.725 4.725C14.2083 4.24167 14.8 4 15.5 4C16.2 4 16.7917 4.24167 17.275 4.725C17.7583 5.20833 18 5.8 18 6.5V10.8H18.65C18.7333 10.8 18.8083 10.8167 18.875 10.85C18.9417 10.8833 19.0167 10.9167 19.1 10.95L22.8 12.75C23.2 12.9333 23.496 13.229 23.688 13.637C23.8793 14.0457 23.9333 14.4667 23.85 14.9L22.95 20.35C22.8667 20.8333 22.6333 21.2293 22.25 21.538C21.8667 21.846 21.4333 22 20.95 22H14.55ZM14.55 20H20.95L21.9 14.55L17.75 12.5H16V6.5C16 6.35 15.9543 6.229 15.863 6.137C15.771 6.04567 15.65 6 15.5 6C15.35 6 15.229 6.04567 15.137 6.137C15.0457 6.229 15 6.35 15 6.5V17.1L10.75 16.2L14.55 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.49792 13.25C5.49792 13.6642 5.16214 14 4.74792 14H1.74792C1.33371 14 0.997925 13.6642 0.997925 13.25V10.25C0.997925 9.83579 1.33371 9.5 1.74792 9.5C2.16214 9.5 2.49792 9.83579 2.49792 10.25V11.4393L4.71759 9.21967C5.01049 8.92678 5.48536 8.92678 5.77825 9.21967C6.07115 9.51256 6.07115 9.98744 5.77825 10.2803L3.55859 12.5H4.74792C5.16214 12.5 5.49792 12.8358 5.49792 13.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H11.25C11.6642 3 12 3.33579 12 3.75V6.75C12 7.16421 11.6642 7.5 11.25 7.5C10.8358 7.5 10.5 7.16421 10.5 6.75V5.56066L8.28033 7.78033C7.98744 8.07322 7.51256 8.07322 7.21967 7.78033C6.92678 7.48744 6.92678 7.01256 7.21967 6.71967L9.43934 4.5H8.25C7.83579 4.5 7.5 4.16421 7.5 3.75Z",
			fill: "currentColor"
		})
	]
});
export default SvgPinchZoomIn;
